
<template>
  <div>
    <div class="help-page">
      <div class="help">
        <div class="help-title">隐私政策</div>
        <div class="help-box1" v-html="info.content"></div>
      </div>
    </div>
  </div>
</template>
<script>
import { articles } from '@/api'
export default {
  data () {
    return {
      info: {}
    }
  },
  created(){
    this.getArticleDetail()
  },
  methods: {
    getArticleDetail() {
      articles({
        id: 2,
      }).then((res) => {
        this.info = res.data;
      });
    },
  }
}
</script>
<style lang="scss" scoped>
.help-page{
  width: 100%;
  height: 100%;
  background: #fff;
  .help{
    width: 80%;
    margin: 0 auto;
    min-width: 1200px;
    background: #fff;
    .help-title{
      width: 100%;
      font-size: 36px;
      height: 120px;
      line-height: 120px;
      text-align: center;
      font-weight: bold;  
    }
    .help-box1{
      width: 1200px;
      box-sizing: border-box;
      padding: 20px;
    }
  }
}
::v-deep .el-main p {
  text-align: left !important;
}
</style>